// CGU.jsx - Conditions Générales d'Utilisation
import React from "react";

const CGU = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          {/* En-tête */}
          <div className="border-b border-gray-200 pb-6 mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Conditions Générales d'Utilisation
            </h1>
            <p className="text-sm text-gray-600">
              Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}
            </p>
          </div>

          {/* Contenu des CGU */}
          <div className="prose prose-gray max-w-none space-y-6">
            {/* Article 1 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 1 - Objet
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Les présentes Conditions Générales d'Utilisation (ci-après « CGU
                ») ont pour objet de définir les modalités et conditions
                d'utilisation du formulaire de candidature en ligne de SE
                Engineering (ci-après « le Service »), ainsi que les droits et
                obligations des parties dans ce cadre.
              </p>
            </section>

            {/* Article 2 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 2 - Acceptation des CGU
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                L'accès et l'utilisation du Service impliquent l'acceptation
                pleine et entière des présentes CGU. En soumettant votre
                candidature, vous reconnaissez avoir pris connaissance de ces
                conditions et vous vous engagez à les respecter.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Si vous n'acceptez pas ces conditions, vous ne devez pas
                utiliser le Service ni soumettre de candidature.
              </p>
            </section>

            {/* Article 3 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 3 - Accès au Service
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Le Service est accessible durant la période définie par SE
                Engineering. Les dates d'ouverture et de fermeture du formulaire
                sont communiquées sur la page du formulaire.
              </p>
              <p className="text-gray-700 leading-relaxed">
                SE Engineering se réserve le droit de modifier, suspendre ou
                interrompre tout ou partie du Service à tout moment, sans
                préavis et sans indemnité.
              </p>
            </section>

            {/* Article 4 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 4 - Conditions de candidature
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Pour soumettre une candidature, vous devez :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Fournir des informations exactes, complètes et à jour</li>
                <li>Joindre un CV au format PDF (taille maximale : 5 Mo)</li>
                <li>Sélectionner deux choix de stages différents</li>
                <li>Utiliser une adresse email valide et unique</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-3">
                <strong>Important :</strong> Une seule candidature par adresse
                email est autorisée. Toute tentative de soumission multiple avec
                la même adresse email sera rejetée.
              </p>
            </section>

            {/* Article 5 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 5 - Traitement des données personnelles
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Dans le cadre de votre candidature, SE Engineering collecte et
                traite vos données personnelles conformément au Règlement
                Général sur la Protection des Données (RGPD) et à la législation
                tunisienne en vigueur.
              </p>
              <div className="bg-gray-50 border-l-4 border-indigo-500 p-4 my-4">
                <h3 className="font-semibold text-gray-900 mb-2">
                  Données collectées :
                </h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700 text-sm">
                  <li>Informations d'identité (nom, prénom)</li>
                  <li>Coordonnées (email, téléphone)</li>
                  <li>
                    Informations académiques (établissement, diplôme,
                    spécialité, année)
                  </li>
                  <li>CV et documents joints</li>
                  <li>Choix de stages</li>
                </ul>
              </div>
              <p className="text-gray-700 leading-relaxed mb-3">
                <strong>Finalité du traitement :</strong> Les données collectées
                sont utilisées exclusivement pour l'évaluation de votre
                candidature et la gestion du processus de recrutement. 
               </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                <strong>Exploitation :</strong> L’Entreprise ne divulgue pas vos données personnelles à des tiers non
                autorisés mais peut de temps en temps utiliser des tiers pour
                agir en son nom. Vous acceptez que vos données personnelles
                puissent être transférées et/ou divulguées à toutes entreprises
                du groupe, ainsi qu’à des tiers agissant pour le compte de
                l’Entreprise. Vous acceptez le transfert de vos données
                personnelles vers des serveurs et des bases de données en dehors
                du pays depuis lequel vous avez postulé chez l’Entreprise. Ce
                transfert peut inclure, par exemple, un transfert et/ou des
                divulgations de vos données personnelles en dehors de l’espace
                économique tunisien.
              </p>
              <p className="text-gray-700 leading-relaxed mb-3">
                <strong>Durée de conservation :</strong> Vos données seront
                conservées pendant une durée maximale de 2 ans à compter de la
                fin du processus de recrutement.
              </p>
              <p className="text-gray-700 leading-relaxed">
                <strong>Vos droits :</strong> Conformément à la réglementation,
                vous disposez d'un droit d'accès, de rectification, de
                suppression et d'opposition au traitement de vos données. Pour
                exercer ces droits, veuillez nous contacter à l'adresse :
                contact@seengineering-tn.com
              </p>
            </section>

            {/* Article 6 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 6 - Obligations du candidat
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                En utilisant le Service, vous vous engagez à :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Ne fournir que des informations véridiques et exactes</li>
                <li>Ne pas usurper l'identité d'une autre personne</li>
                <li>Ne pas soumettre de documents frauduleux ou falsifiés</li>
                <li>
                  Ne pas tenter de contourner les mesures de sécurité du Service
                </li>
                <li>
                  Respecter la limitation d'une candidature par adresse email
                </li>
                <li>
                  Ne pas utiliser le Service à des fins illégales ou contraires
                  aux présentes CGU
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-3">
                Toute violation de ces obligations peut entraîner le rejet
                immédiat de votre candidature et l'exclusion définitive du
                processus de recrutement.
              </p>
            </section>

            {/* Article 7 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 7 - Responsabilité
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                SE Engineering met tout en œuvre pour assurer la disponibilité
                et la sécurité du Service. Toutefois, SE Engineering ne saurait
                être tenu responsable :
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Des interruptions ou dysfonctionnements du Service</li>
                <li>
                  De la perte de données résultant d'un problème technique
                </li>
                <li>
                  Des dommages directs ou indirects résultant de l'utilisation
                  du Service
                </li>
                <li>
                  De l'inexactitude des informations fournies par le candidat
                </li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-3">
                Il appartient au candidat de prendre toutes les mesures
                appropriées pour protéger ses propres données et équipements
                contre toute atteinte.
              </p>
            </section>

            {/* Article 8 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 8 - Propriété intellectuelle
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Tous les éléments du Service (textes, images, logos, icônes,
                etc.) sont la propriété exclusive de SE Engineering ou de ses
                partenaires. Toute reproduction, représentation, modification ou
                exploitation, totale ou partielle, sans l'autorisation expresse
                de SE Engineering est interdite.
              </p>
            </section>

            {/* Article 9 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 9 - Modification des CGU
              </h2>
              <p className="text-gray-700 leading-relaxed">
                SE Engineering se réserve le droit de modifier à tout moment les
                présentes CGU. Les nouvelles conditions seront applicables dès
                leur mise en ligne. Il est conseillé au candidat de consulter
                régulièrement cette page pour prendre connaissance des
                éventuelles modifications.
              </p>
            </section>

            {/* Article 10 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 10 - Droit applicable et juridiction
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Les présentes CGU sont régies par le droit tunisien. En cas de
                litige relatif à l'interprétation ou à l'exécution des
                présentes, et à défaut de résolution amiable, les tribunaux
                tunisiens seront seuls compétents.
              </p>
            </section>

            {/* Article 11 */}
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                Article 11 - Contact
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Pour toute question relative aux présentes CGU ou au Service,
                vous pouvez nous contacter :
              </p>
              <div className="bg-indigo-50 rounded-lg p-4">
                <p className="text-gray-800 font-semibold mb-2">
                  SE Engineering
                </p>
                <p className="text-gray-700 text-sm">
                  Email : contact@seengineering-tn.com
                </p>
                <p className="text-gray-700 text-sm">
                  Téléphone : +216 51 418 880
                </p>
                <p className="text-gray-700 text-sm">
                  Adresse : Ksibet El Mediouni, Tunisie
                </p>
              </div>
            </section>
          </div>

          {/* Pied de page */}
          <div className="mt-12 pt-6 border-t border-gray-200">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <button
                onClick={() => window.history.back()}
                className="px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
              >
                ← Retour
              </button>
              <button
                onClick={() => window.print()}
                className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
              >
                Imprimer / Télécharger
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGU;
